// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IgRy","icon":"styles_icon__2vklL"};